import * as React from "react";
import * as TFS_Agile_Controls from "Agile/Scripts/Common/Controls";
import * as AgileControlsResources from "Agile/Scripts/Resources/TFS.Resources.AgileControls";
import * as Controls from "VSS/Controls";
import { registerLWPComponent } from "VSS/LWP";

export interface ISprintBurndownChartProps {
    /** Current iteration name*/
    iterationName: string;

    /** Current iteration path*/
    iterationPath: string;

    /** Team id to render the chart for */
    teamId: string;
}

export class LegacySprintBurndownChartComponent extends React.Component<ISprintBurndownChartProps, {}> {
    private _burndownControl: TFS_Agile_Controls.BurndownChartControl;
    private _containerRef: HTMLDivElement;

    public render(): JSX.Element {
        return (
            <div
                ref={this._setContainerRef}
                className="burndown-chart parent"
            />
        );
    }

    public shouldComponentUpdate(nextProps: ISprintBurndownChartProps): boolean {
        return (
            this.props.iterationPath !== nextProps.iterationPath ||
            this.props.teamId !== nextProps.teamId ||
            !this._burndownControl
        );
    }

    public componentDidUpdate() {
        this._createControl();
    }

    public componentDidMount() {
        this._createControl();
    }

    public componentWillUnmount() {
        this._destroyControl();
    }

    private _createControl() {
        this._destroyControl();

        const { teamId, iterationName, iterationPath } = this.props;

        const burndownChartOptions: any = {
            title: `${AgileControlsResources.Burndownchart_TitlePrefix} ${iterationName}`,
            iterationPath: iterationPath,
            teamId: teamId
        };

        const chartContainer = $("<div>", {
            class: "burndown-chart small-chart-container"
        });
        chartContainer.appendTo($(this._containerRef));

        this._burndownControl = Controls.Enhancement.enhance(
            TFS_Agile_Controls.BurndownChartControl,
            chartContainer,
            burndownChartOptions
        ) as TFS_Agile_Controls.BurndownChartControl;
    }

    private _setContainerRef = ref => {
        this._containerRef = ref;
    };

    private _destroyControl() {
        if (this._burndownControl) {
            this._burndownControl.dispose();
            this._burndownControl = null;
        }
    }
}

registerLWPComponent(
    "legacyBurndownChartControl",
    LegacySprintBurndownChartComponent
);